import { Box, PageBlock, Stack } from 'braid-design-system';

import { NewsletterSignUpForm } from './NewsletterSignUpForm';
import { SiteWideFooterLinksSection } from './SiteWideFooterLinksSection';

interface SiteWideFooterProps {
  showNewsletterSignUp?: boolean;
}

export function SiteWideFooter(props: SiteWideFooterProps) {
  return (
    <Box
      component="footer"
      aria-label="Main footer"
      data={{ testid: 'navigation-footer' }}
    >
      <PageBlock width="large">
        <Stack space="xxxlarge">
          {props.showNewsletterSignUp && <NewsletterSignUpForm />}

          <Box paddingBottom="xlarge">
            <SiteWideFooterLinksSection />
          </Box>
        </Stack>
      </PageBlock>
    </Box>
  );
}
